// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TextFieldProps } from "@ces/MobiusOverrides/TextField/TextField";
import { color, xScreen } from "@ces/XDL/Utilities";
import translate from "@insite/client-framework/Translate";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { DatePickerPresentationProps } from "@insite/mobius/DatePicker";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { TagPresentationProps } from "@insite/mobius/Tag";
import { TextFieldPresentationProps } from "@insite/mobius/TextField";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

interface MyAccountFilterSectionStyles {
    filterContainer?: GridContainerProps;
    clearButton?: ButtonPresentationProps;
    fromDate?: DatePickerPresentationProps;
    toDate?: DatePickerPresentationProps;
    orderTotalGridItem?: GridItemProps;
    datesGridItem?: GridItemProps;
    orderTotalAmountTextField?: TextFieldPresentationProps;
    appliedFilterTag?: TagPresentationProps;
    appliedFiltersContainer?: InjectableCss;
    searchFieldWrapper?: InjectableCss;
}

const myAccountFilterSectionStyles: MyAccountFilterSectionStyles = {
    filterContainer: {
        gap: 20,
        offsetCss: css`
            > ${GridItemStyle} {
                padding-top: 8px;
                padding-bottom: 8px;
            }
        `,
        css: css`
            padding: 20px 13px 13px 13px;
            ${xScreen("lte", "md")} {
                padding: 0;
            }
        `,
    },
    clearButton: {
        variant: "tertiary",
        css: css`
            margin-top: 4px;
            ${xScreen("lte", "md")} {
                width: 100%;
            }
        `,
    },
    orderTotalGridItem: {
        width: [12, 12, 12, 4, 4],
    },
    orderTotalAmountTextField: {
        cssOverrides: {
            formInputWrapper: css`
                margin-top: 0;
            `,
        },
        css: css`
            &:hover {
                border-color: ${color("common.ui8")};
            }
        `,
        label: translate("Amount"),
    } as TextFieldProps,
    datesGridItem: {
        width: [12, 12, 12, 4, 4],
    },
    fromDate: {
        cssOverrides: {
            formField: css`
                width: 100%;
            `,
        },
    },
    toDate: {
        cssOverrides: {
            formField: css`
                width: 100%;
            `,
            datePicker: css`
                ${xScreen("lte", "md")} {
                    .react-calendar {
                        left: unset;
                        right: 0;
                    }
                }
            `,
        },
    },
    appliedFiltersContainer: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
        `,
    },
    appliedFilterTag: {
        css: css`
            margin: 0;
        `,
    },
    searchFieldWrapper: {
        css: css`
            width: 100%;
            flex: 0 1 calc(16.66% - 20px);
            min-width: 130px;

            ${xScreen("lte", "md")} {
                flex: 1;
                min-width: 100%;
                max-width: 100%;
            }
        `,
    },
};

export default myAccountFilterSectionStyles;
